import type { DomainMapper } from '../types';

const fi: DomainMapper = {
  countryCode: 'fi',
  currency: 'EUR',
  dataAreaId: 'fi50',
  domain: 'localhost:3011',
  environment: 'local',
  flagUrl: '/flags/FI.svg',
  languagePrimary: true,
  locale: 'fi',
  logoUrl: 'kahrs-logo',
  noRobots: true,
  productBasePath: 'tuote',
  sitemapUrl: 'https://kahrs-api.test/storage/sitemaps/sitemap-fi.xml',
  storyblokBasePath: 'fi',
  url: 'https://localhost:3011/fi',
  algoliaIndex: 'b2b-fi-fi-FI-products',
  algoliaIndexAutocomplete: 'b2b-fi-fi-FI-products_query_suggestions',
  algoliaIndexPages: 'content_',
  applicationId: 1354, // stage
  //applicationId: 1358, // prod
  subFolder: true,
  b2b: {
    enabled: true,
    purchaseEnabled: true,
    storyblokBasePath: 'b2b',
    applicationId: 1354, // stage
    //applicationId: 1358, // prod
    algoliaIndex: 'b2b-fi-fi-FI-products',
    algoliaIndexAutocomplete: 'b2b-fi-fi-FI-products_query_suggestions',
    displayIncVat: false,
    default: true,
    productBasePath: 'b2b/tuote',
    sitemapUrl: 'https://kahrs-api.test/storage/sitemaps/sitemap-fi.xml',
    features: {
      enableCheckoutV2: true,
    },
  },
  b2c: {
    enabled: true,
    purchaseEnabled: true,
    storyblokBasePath: '',
    applicationId: 1470, // stage
    //applicationId: 1475, // prod
    algoliaIndex: 'b2c-fi-fi-FI-products',
    algoliaIndexAutocomplete: 'b2c-fi-fi-FI-products_query_suggestions',
    displayIncVat: true,
    default: false,
    productBasePath: 'tuote',
    sitemapUrl: 'https://kahrs-api.test/storage/sitemaps/sitemap-fi-b2c.xml',
    features: {
      enableCheckoutV2: true,
    },
  },
  features: {
    fastOrder: true,
    backorders: false,
    cartSettings: true,
    sampleInventory: true,
  },
  showNonPublicProducts: true,
} as DomainMapper;

export default fi;
